import React from 'react';
import { translateResourceString } from '../util/translationUtility';
import { ERROR_USER_ALERT } from '../SharedComponents/UserMessaging/userAlertTypes';
import fetch from 'cross-fetch';
import invoiceEventBusClient from '../util/invoiceEventBusClient';

const braintreeLoadTimeoutDuration = 15000;

const makeDropinConfig = (token, amount, locale, { UsePaypal, UsePaypalCredit, BraintreePaypalFlow, Currency }) => {
    function getSupportedLocale(inLocale = "") {
        var supportedLocales =
            [// BBS DDD 2017-09-07 https://braintree.github.io/braintree-web/3.22.2/PayPalCheckout.html#createPayment retrieved 2017-09-07
                "en_US", "da_DK", "de_DE", "en_AU", "en_GB", "es_ES", "fr_CA", "fr_FR", "id_ID", "it_IT", "ja_JP",
                "ko_KR", "nl_NL", "no_NO", "pl_PL", "pt_BR", "pt_PT", "ru_RU", "sv_SE", "th_TH", "zh_CN", "zh_HK", "zh_TW"
            ],
            preferredLocale = inLocale.toLowerCase(),
            i = 0,
            found = false;
        supportedLocales.forEach(function (locale, idx, arr) {
            if (found) return;
            if (preferredLocale === locale.toLowerCase()) {
                found = true;
                i = idx;
            }
        });
        if (found) return supportedLocales[i];
        supportedLocales.forEach(function (locale, idx, arr) {
            if (found) return;
            if (locale.toLowerCase().substring(0, preferredLocale.length) === preferredLocale) {
                found = true;
                i = idx;
            }
        });
        if (i > -1) return supportedLocales[i];
        return "";
    }

    const inLocale1 = typeof window !== 'undefined' &&
        window.navigator &&
        window.navigator.language &&
        window.navigator.language.replace
        ? window.navigator.language.replace('-', '_')
        : '';
    var dropinConfig = {
        authorization: token,
        container: "#braintreeHolder",
        locale: locale ||
            getSupportedLocale(
                inLocale1),
        card: {
            overrides: {
                fields: {
                    postalCode: null
                }
            },
            vault: {
                allowVaultCardOverride: false,
                vaultCard: false
            }
        },
    }
    const paypalConfig = { flow: BraintreePaypalFlow, amount, currency: Currency };
    if (UsePaypal) {
        dropinConfig.paypal = paypalConfig
        if (UsePaypalCredit) {
            dropinConfig.paypalCredit = paypalConfig
        }
    }
    return dropinConfig;
}

class BraintreePaymentComponent extends React.Component {
    constructor(props) {
        super(props);
        const { BraintreePaymentNonce, amount } = props;
        this.initBraintree = this.initBraintree.bind(this);
        this.onBraintreeLoadTimeout = this.onBraintreeLoadTimeout.bind(this)
        this.onClientTokenReceived = this.onClientTokenReceived.bind(this)
        this.initBraintree = this.initBraintree.bind(this)
        this.componentDidUpdate = this.componentDidUpdate.bind(this)
        this.onClickSuccess = this.onClickSuccess.bind(this)
        this.onDropinCreated = this.onDropinCreated.bind(this)
        this.onStartOver = this.onStartOver.bind(this)
        this.dropin = null
        this.viewStateChange = this.viewStateChange.bind(this);
        this.billingAddressInvalid = this.billingAddressInvalid.bind(this);
        this.requestPaymentMethod = this.requestPaymentMethod.bind(this);
        this.onPaymentMethodRequestable = this.onPaymentMethodRequestable.bind(this);

        this.state = {
            btInitializing: false,
            dropinInstance: null,
            paymentMethodAvailable: false,
            btLoaded: false,
            nonce: BraintreePaymentNonce,
            saveCard: false,
            billingAddressRequired: false,
            amount: amount,
            shouldRequestPaymentMethod: true
        }
    }

    componentWillUnmount() {
        this.state.dropinInstance && this.state.dropinInstance.teardown();
        this.setState({ dropinInstance: null, paymentMethodAvailable: false, btLoaded: false })
        invoiceEventBusClient.remove("paymentsUpdated");
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.btLoaded && !prevState.btInitializing && !this.state.btLoaded && !this.state.btInitializing) {
            this.initBraintree(this.props);
        }
    }

    componentDidMount() {
        this.dropin = require('braintree-web-drop-in')
        if (!this.state.nonce || this.state.nonce.length < 1) {
            if (!this.state.btLoaded && !this.state.btInitializing) {
                this.initBraintree(this.props);
            }
        }

        invoiceEventBusClient.on("paymentsUpdated", () => {
            this.state.dropinInstance && this.state.dropinInstance.teardown();
            this.setState({ dropinInstance: null, paymentMethodAvailable: false, btLoaded: false })
            if (!this.state.nonce || this.state.nonce.length < 1) {
                if (!this.state.btLoaded && !this.state.btInitializing) {
                    this.initBraintree(this.props);
                }
            }
        });
    }

    onStartOver(e) {
        e.preventDefault();
        this.props.onStartOver();
        this.state.dropinInstance && this.state.dropinInstance.teardown();
        this.setState({ btInitializing: false, nonce: '', btLoaded: false, paymentMethodAvailable: false });
        this.initBraintree(this.props);
    }

    onBraintreeLoadTimeout() {
        if (!this.state.btLoaded) {
            this.props.onBraintreeLoadTimeout();
        }
    }

    onDropinCreated(createErr, dropinInstance) {
        this.setState({ btInitializing: false });
        if (createErr) {
            this.props.onCreateDropinError(
                `${translateResourceString("/MyAccountPage/InvoicePayments/Braintree/ErrorInitializingBraintree")}: ${createErr}. ${translateResourceString("/MyAccountPage/InvoicePayments/Braintree/PleaseReloadOrContactCustomerService")}`,
                createErr);
            console.error(createErr);
            return;
        }
        this.setState({
            dropinInstance: dropinInstance,
            btLoaded: true,
            paymentMethodAvailable: dropinInstance.isPaymentMethodRequestable(),
            billingAddressRequired: !dropinInstance.isPaymentMethodRequestable(),
        });
        dropinInstance.on('paymentMethodRequestable', (event) => this.onPaymentMethodRequestable(event));
        dropinInstance.on('noPaymentMethodRequestable', () => this.setState({ paymentMethodAvailable: false }));
        dropinInstance.on('changeActiveView', (view) => this.viewStateChange(view));
        
        if (dropinInstance.isPaymentMethodRequestable()){
            this.requestPaymentMethod();
        }
    }

    onPaymentMethodRequestable(event) {
        this.setState({ paymentMethodAvailable: true });
        if (event.paymentMethodIsSelected && this.state.shouldRequestPaymentMethod) {
            this.requestPaymentMethod();
        }
    }

    onClientTokenReceived(token, nextProps) {
        var dropinConfig = makeDropinConfig(token, nextProps.amount, null, nextProps.settings);
        this.dropin.create(dropinConfig, this.onDropinCreated);
    }

    initBraintree(props) {
        // Don't run this server-side
        if (typeof window === 'undefined') {
            console.log('prevented initBraintree')
            return;
        }
        if (this.state.btInitializing) {
            console.error("Warning: braintree already initialized or still initializing");
            return;
        }
        this.setState({ btInitializing: true, btLoaded: false });
        setTimeout(this.onBrainteeLoadTimeout, braintreeLoadTimeoutDuration);
        const clientTokenEndpoint = props.braintreeClientTokenEndpoint;

        fetch(clientTokenEndpoint,
            {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                credentials: 'same-origin',
                body: JSON.stringify(props.placeOrderDetails)
            })
            .then((response) => {
                if (response.ok)
                    return response.json();
                throw new Error(`${response.status}: ${response.statusText}`)
            })
            .then((clientTokenResult) => {
                if (clientTokenResult.Success)
                    this.onClientTokenReceived(clientTokenResult.Token, props, this.dropin);
                else
                    props.onClientTokenFailed(clientTokenResult.canRetry, clientTokenResult.ErrorMessage);
            }).catch((error) => {
                props.onClientTokenFailed(false, error.message);
            });
    }

    onClickSuccess(e) {
        e && e.preventDefault && e.preventDefault();
        if(this.state.saveCard) {
            invoiceEventBusClient.dispatch("reloadWallet", {message: "reload wallet"});
        }
        this.requestPaymentMethod();
        this.setState({shouldRequestPaymentMethod: false});
    }


    requestPaymentMethod() {
        const {
            dropinInstance,
            amount,
            streetAddress,
            extendedAddress,
            locality,
            region,
            postalCode,
            billingAddressRequired,
            saveCard
        } = this.state;

        const {
            onSuccessNoDropin,
            usTwoLetterCountryCode,
            usThreeLetterCountryCode
        } = this.props;

        if (!dropinInstance) {
            onSuccessNoDropin(
                translateResourceString("/MyAccountPage/InvoicePayments/Braintree/SomethingWentWrong"),
                `dropin is undefined or wrong: ${dropinInstance}`);
        }

        // Likely not using this
        const threeDSecure = {
            threeDSecure: {
                amount: amount
            }
        };

        const billingAddress = billingAddressRequired ? {
            streetAddress: streetAddress,
            extendedAddress: extendedAddress,
            locality: locality,
            region: region,
            postalCode: postalCode,
            countryCodeAlpha2: usTwoLetterCountryCode,
            countryCodeAlpha3: usThreeLetterCountryCode
        } : null;

        if (billingAddressRequired) {
            threeDSecure.threeDSecure.billingAddress = billingAddress;
        }
        
        
        const delay = (ms) => {
            return new Promise(resolve => setTimeout(resolve, ms));
        }
        
        const setRequestPaymentState = () => {
            this.setState({ shouldRequestPaymentMethod: true }, () => {
                try {
                    dropinInstance.requestPaymentMethod(threeDSecure, (getPaymentErr, payload) => {
                        if (getPaymentErr) {
                            this.props.onSuccessNoDropin(translateResourceString("/MyAccountPage/InvoicePayments/Braintree/ErrorGettingPaymentMethod") + ": " +
                                getPaymentErr,
                                getPaymentErr);
                            return;
                        }
                        this.setState({ nonce: payload.nonce }); 
                        this.props.onSuccesfulRequest(payload, billingAddress, saveCard);  
                    })
                }
                catch(e) {
                    console.log("Dropin not created.")
                    console.log(e);
                }
            });
        }
        /* Braintree Drop-In Error: https://github.com/braintree/braintree-web-drop-in/issues/399 
        *  If the drop-in model is not set, retry after a time interval of 75ms */
        if (!dropinInstance) return;

        if(billingAddress){
            setRequestPaymentState();
        }
        else {
            let remainingTries = 3;
            while (remainingTries > 0) {
            delay((3 - remainingTries) * 75).then(() => {
                    setRequestPaymentState();
                    remainingTries = 0;
                }).catch(remainingTries--);
            }
        }
    }

    viewStateChange(viewState) {
        this.setState({ billingAddressRequired: viewState.newViewId === "card" });
    }

    billingAddressInvalid(street, extended, locality, region, postalCode) {
        return !street || street.length === 0 ||
            !locality || locality.length === 0 ||
            !region || region.length === 0 ||
            !postalCode || postalCode.length === 0;
    }

    render() {
        const {
            nonce,
            billingAddressRequired,
            btInitializing,
            paymentMethodAvailable,
            streetAddress,
            extendedAddress,
            locality,
            region,
            postalCode,
        } = this.state;
        const { states } = this.props;
        const disabled = (btInitializing || !paymentMethodAvailable || (billingAddressRequired && this.billingAddressInvalid(streetAddress, extendedAddress, locality, region, postalCode)));
        let content = (
                <div>
                    <div id="braintreeHolder" style={{ paddingBottom: 10 }} />
                    {btInitializing &&
                        <div style={{ paddingBottom: 10 }}><span className="fas fa-spinner fa-spin" /></div>
                    }
                    {billingAddressRequired &&
                        <div className="container p-0">
                            <div className="row">
                                <div className="col-12">
                                    <div className="input-container">
                                        <div className="form-check mb-2" style={{ lineHeight: "1", paddingLeft: "2rem" }}>
                                            <input className="form-check-input"
                                                type="checkbox"
                                                name="invoicePaymentSaveCard"
                                                id="invoicePaymentSaveCard"
                                                checked={this.state.storeNewCard}
                                                onChange={(e) => this.setState({ saveCard: e.target.checked })}
                                                style={{ marginLeft: "-2rem" }}
                                            />
                                            <label className="form-check-label"
                                                htmlFor="invoicePaymentSaveCard"
                                            >{translateResourceString("/MyAccountPage/InvoicePayments/Braintree/SaveCard")}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="input-container">
                                        <label htmlFor="invoicePaymentStreetAddress">{translateResourceString("/MyAccountPage/InvoicePayments/Braintree/Address/Address1")}</label>
                                        <input type="text" name="invoicePaymentStreetAddress" id="invoicePaymentStreetAddress" className="form-control" placeholder="" value={streetAddress} onChange={(e) => this.setState({ streetAddress: e.target.value })} />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="input-container">
                                        <label htmlFor="invoicePaymentExtendedAddress">{translateResourceString("/MyAccountPage/InvoicePayments/Braintree/Address/Address2")}</label>
                                        <input type="text" name="invoicePaymentExtendedAddress" id="invoicePaymentExtendedAddress" className="form-control" placeholder="" value={extendedAddress} onChange={(e) => this.setState({ extendedAddress: e.target.value })} />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="input-container">
                                        <label htmlFor="invoicePaymentLocality">{translateResourceString("/MyAccountPage/InvoicePayments/Braintree/Address/City")}</label>
                                        <input type="text" name="invoicePaymentLocality" id="invoicePaymentLocality" className="form-control" placeholder="" value={locality} onChange={(e) => this.setState({ locality: e.target.value })} />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6">
                                    <div className="iframe-input-group input-container">
                                        <label htmlFor="invoicePaymentRegion">{translateResourceString("/MyAccountPage/InvoicePayments/Braintree/Address/State")}</label>
                                        <select name="invoicePaymentRegion" id="invoicePaymentRegion" className="form-control" value={region} onChange={(e) => this.setState({ region: e.target.value })}>
                                            {states.map((state, i) => (<option key={i} value={state.Code}>{state.Name}</option>))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="iframe-input-group input-container">
                                        <label htmlFor="invoicePaymentPostalCode">{translateResourceString("/MyAccountPage/InvoicePayments/Braintree/Address/PostalCode")}</label>
                                        <input type="text" name="invoicePaymentPostalCode" id="invoicePaymentPostalCode" className="form-control" placeholder="" value={postalCode} onChange={(e) => this.setState({ postalCode: e.target.value })} />
                                    </div>
                                </div>
                            </div>
                            <button
                                className={`btn btn-primary ${disabled ? "disabled" : ""}`}
                                onClick={e => this.onClickSuccess(e)}
                                onKeyPress={e => e.key === "Enter" && this.onClickSuccess()}
                                style={{ marginRight: 20 }}
                                tabIndex={0}
                                disabled={disabled}
                            >
                                {translateResourceString("/MyAccountPage/InvoicePayments/Braintree/UseMethodButton")}
                            </button>
                    </div>
                }
            </div>
        )
        
        return (
            <div className="braintreePayment">
                {content}
            </div>
        );
    }
}

const BraintreePaymentComponentWrapper = (props) => {

    const notifyError = (message, consoleErrorMessage) => {
        props.addMessage({
            text: message,
            type: ERROR_USER_ALERT
        });
        console.error(consoleErrorMessage);
    };

    const mapBraintreePaymentStateToProps = {
        settings: props.braintreeClientSettings,
        amount: props.amount,
        braintreeClientTokenEndpoint: props.braintreeClientTokenEndpoint,
        BraintreePaymentNonce: props.braintreePaymentNonce,
    }

    const mapBraintreePaymentDispatchToProps = {
        onBraintreeLoadTimeout: () => notifyError(translateResourceString("/MyAccountPage/InvoicePayments/Braintree/FailedToLoad"),
            `Braintree form load timed out after ${braintreeLoadTimeoutDuration}ms`),
        onClientTokenFailed: (canRetry, serverMessage) => {
            const retryMessage = (canRetry) ? translateResourceString("/MyAccountPage/InvoicePayments/Braintree/ErrorSecondPartReload") : translateResourceString("/MyAccountPage/InvoicePayments/Braintree/ErrorSecondPartContactService");
            const text = `${translateResourceString("/MyAccountPage/InvoicePayments/Braintree/ErrorFirstPart")} ${retryMessage}`;
            notifyError(text, `message from server: "${serverMessage}"`);
        },
        onCreateDropinError: (text, diagnosticText) => notifyError(text, diagnosticText),
        onSuccesfulRequest: (payload, billingAddress, saveCard) => {
            props.updateBraintreePaymentData(payload, billingAddress, saveCard);
        },
        onSuccessNoDropin: (text, diagnosticText) => notifyError(text, diagnosticText),
        onStartOver: () => props.updateBraintreePaymentData(null, null, false)
    }

    return <BraintreePaymentComponent
        {...mapBraintreePaymentStateToProps}
        {...mapBraintreePaymentDispatchToProps}
        {...props}
    />
}

export default BraintreePaymentComponentWrapper